import { render } from "./detail-supporting-docs.vue?vue&type=template&id=7909b8d2&scoped=true&ts=true"
import script from "./detail-supporting-docs.vue?vue&type=script&lang=ts"
export * from "./detail-supporting-docs.vue?vue&type=script&lang=ts"

import "./detail-supporting-docs.vue?vue&type=style&index=0&id=7909b8d2&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7909b8d2"]])

export default __exports__